import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { initNativeShell } from "./native";

const root = createRoot(document.getElementById("root"));
root.render(<App />);

// ───────────── Animated launch splash dismiss ─────────────
// `public/index.html` ships an inline animated splash that paints
// immediately on PWA / Capacitor cold-launch (well before React boots).
// We fade it out after React has mounted and rendered its first frame,
// so the handoff feels seamless. A minimum 700ms hold lets the user
// actually SEE the animation rather than have it flash on a fast device.
window.addEventListener("load", () => {
  const minHold = 700;
  const start = performance.now();
  // Two RAFs ≈ guaranteed React has committed the first paint
  requestAnimationFrame(() => requestAnimationFrame(() => {
    const elapsed = performance.now() - start;
    setTimeout(() => window.__hideSplash && window.__hideSplash(),
               Math.max(0, minHold - elapsed));
  }));
});

// ───────────── PWA: service-worker registration ──────────────
// Only register in production builds. CRA dev server doesn't ship the file.
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .catch(() => { /* SW unavailable — degrade gracefully */ });
  });
}

// ───────────── Native shell wiring (Capacitor) ──────────────
// No-op on web; on Android/iOS it sets status bar, hides splash, and wires
// the hardware back button to React Router.
initNativeShell().catch(() => { /* native shell missing — degrade gracefully */ });
